import Vue from 'vue'

// Styles
import './sass/styles.scss'

// Scripts
import './js/modernizr'
import './js/unveil'
import './js/layout'
import './js/scroll-lock'
import './js/menu'
import './js/scroll-helpers'
import './js/data-href-link'
import './js/scrollmagic'

// Analytics
import analytics from './js/analytics'
analytics.initialize()

// Axios
import '../shared/axios'

// EventHub
import EventHub from './vue/components/occasions/eventHub'
window.EventHub = EventHub.init()

// Vue
window.Vue = Vue
Vue.component('popup', () => import('./vue/components/popup'))
Vue.component('voorraad', () => import('./vue/components/occasions'))
Vue.component('occasions', () => import('./vue/components/occasions'))
Vue.component('reviews-slider', () => import('./vue/components/reviews-slider'))
Vue.component('share-occasion', () => import('./vue/components/share-occasion'))
Vue.component('photos-uploader', () => import('./vue/components/photos-uploader'))
Vue.component('fileupload', () => import('./vue/components/fileupload'))
new Vue({ el: '#wrapper' })

// Whooohoo, lets go!
let ElementRoutes = {
    'form.form-generic' () {
        require('./js/forms/generic')
    },
    'img[data-src]' () {
        require('./js/unveil')
    },
    '.card2' () {
        require('./js/card2')
    },
    '.boxy10.-lists' () {
        require('./js/boxy10')
    },
    '.magicline-list' () {
        require('./js/magicline')
    },
    '.wow' () {
        require.ensure([], () => {
            require('./js/wow')
        })
    },
    '[data-photoswipe]' () {
        require('./js/photoswipe')
    },
};

$.each(ElementRoutes, (key, callback) => {
    if ($(key).length) {
        callback()
        console.info('✓ ' + key)
    }
})

// Trigger click helper
$(document).on('click touchstart', '[data-trigger-click]', function (e) {
    try {
        e.preventDefault()
        $(this.getAttribute('data-trigger-click')).trigger('click')
    } catch (e) {
        //
    }
})

$('a[disabled]').click(e => e.preventDefault())

// Test for iPad or iPhone
if (navigator.userAgent.match(/(iPad|iPhone)/g)) {
    $('html').addClass('-is-ios')
}

// Op touchdevices niet bij scrollen de gallery openen
document.querySelectorAll('.photosbox').forEach(item => {
    item.addEventListener('touchstart', event => {
        event.stopPropagation()
    })
})

const bottomEl = document.getElementById('bottom')
if (bottomEl) {
    $('.afspraakknop')
        .removeClass('hidden')
        .on('click', function(){
            $('#afspraakwrapper').removeClass('hidden');
        });
    
    $('#afspraakmaken .close, #afspraakwrapper')
        .on('click', function(){
            $('#afspraakwrapper').addClass('hidden');
        });

    $('.belknop')
        .removeClass('hidden')
        .click((event) => {
            event.preventDefault()

            const cards = $(bottomEl).find('.card8')

            window.scrollTo({
                top: $(bottomEl).find('.card8-body').first().offset().top,
                behavior: 'smooth',
            })

            // window.location.hash = 'bottom'

            setTimeout(() => {
                cards.addClass('js-flash')
                setTimeout(() => {
                    cards.removeClass('js-flash')
                }, 800)
            }, 500)
        })
}
